/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface RecommendedService
 */
export interface RecommendedService {
  /**
   *
   * @type {string}
   * @memberof RecommendedService
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof RecommendedService
   */
  url: string
  /**
   *
   * @type {number}
   * @memberof RecommendedService
   */
  sortOrder: number
  /**
   *
   * @type {number}
   * @memberof RecommendedService
   */
  price?: number
}

/**
 * Check if a given object implements the RecommendedService interface.
 */
export function instanceOfRecommendedService(
  value: object
): value is RecommendedService {
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('url' in value) || value['url'] === undefined) return false
  if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false
  return true
}

export function RecommendedServiceFromJSON(json: any): RecommendedService {
  return RecommendedServiceFromJSONTyped(json, false)
}

export function RecommendedServiceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RecommendedService {
  if (json == null) {
    return json
  }
  return {
    title: json['title'],
    url: json['url'],
    sortOrder: json['sortOrder'],
    price: json['price'] == null ? undefined : json['price'],
  }
}

export function RecommendedServiceToJSON(
  value?: RecommendedService | null
): any {
  if (value == null) {
    return value
  }
  return {
    title: value['title'],
    url: value['url'],
    sortOrder: value['sortOrder'],
    price: value['price'],
  }
}
